module.exports = __webpack_public_path__ + "static/media/delete.863155c5.svg";